import { STATUSPAGE } from '@repo/ui';
import { HandleActivitiesQuantityPerStudentUseCaseInterface } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import { loadFilters } from 'presentation/config/store/reports/activites-quantity-per-student-slice';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { IActivitiesQuantityPerStudentFilters } from '../models/activities-quantity-per-student-filters';

export const useActivitiesQuantityPerStudent = () => {
  // Hooks
  const dispatch = useDispatch();
  const { reportService } = useService();

  // States
  const { filters } = useAppSelector(
    (state) => state.activitiesQuantityPerStudent,
  );
  const [loading, setLoading] = useState<STATUSPAGE>(STATUSPAGE.DONE);
  const [selectedSubmitBtn, setSelectedSubmitBtn] = useState<string>();

  // Methods
  const requestHandleActivitiesQuantityPerStudent = useCallback(
    (params: HandleActivitiesQuantityPerStudentUseCaseInterface.Params) => {
      setLoading(STATUSPAGE.LOADING);
      reportService
        .handleActivitiesQuantityPerStudent(params)
        .then((res: any) => {
          let blob = new Blob([res], {
            type: `application/${params?.type === 'pdf' ? 'pdf' : 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'}`,
          });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, '_blank');
        })
        .catch((err) => {
          notifyError(err.message);
        })
        .finally(() => {
          setLoading(STATUSPAGE.DONE);
        });
    },
    [],
  );

  const saveFilters = useCallback(
    (params: IActivitiesQuantityPerStudentFilters) => {
      dispatch(loadFilters(params));
    },
    [],
  );

  return {
    // States
    filters,
    loading,
    selectedSubmitBtn,
    // Methods
    setLoading,
    saveFilters,
    setSelectedSubmitBtn,
    requestHandleActivitiesQuantityPerStudent,
  };
};
